module.exports = __webpack_public_path__ + "img/social-media-discussion-dark.96803f22.svg";